
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Settings, CheckCircle, Wrench, Zap, Shield, AlertTriangle, Cog, Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function TeknikKontroller() {
  const { t } = useTranslation();

  const technicalServices = [
    {
      icon: Settings,
      title: t('services.teknik.elevator'),
      description: 'Asansörlerin güvenli çalışması için zorunlu periyodik kontrol ve muayene hizmetleri',
      features: [
        'Güvenlik sistemleri kontrolü',
        'Mekanik aksamların muayenesi',
        'Elektrik tesisatı kontrolü',
        'Acil durum sistemleri testi',
        'Yasal uygunluk belgesi'
      ],
      image: 'https://public.readdy.ai/ai/img_res/2cdd7cb454a3b819ad1b33737f073c86.jpg'
    },
    {
      icon: Cog,
      title: t('services.teknik.escalator'),
      description: 'Yürüyen merdiven ve yürüyen bantların güvenlik kontrolü ve periyodik muayenesi',
      features: [
        'Güvenlik sensörleri kontrolü',
        'Motor ve tahrik sistemi muayenesi',
        'Fren sistemleri testi',
        'Acil durdurma sistemleri',
        'Basamak ve korkuluk kontrolü'
      ],
      image: 'https://readdy.ai/api/search-image?query=Escalator%20maintenance%20inspection%20with%20professional%20technician%20examining%20moving%20walkway%20systems%2C%20safety%20mechanisms%2C%20modern%20shopping%20center%20environment%2C%20technical%20equipment&width=600&height=400&seq=8&orientation=landscape'
    },
    {
      icon: Zap,
      title: t('services.teknik.photovoltaic'),
      description: 'Güneş enerji sistemlerinin performans ve güvenlik kontrolü',
      features: [
        'Panel verimliliği ölçümü',
        'Elektrik bağlantıları kontrolü',
        'İnvertör performans testi',
        'Güvenlik sistemleri kontrolü',
        'Performans raporu hazırlama'
      ],
      image: 'https://readdy.ai/api/search-image?query=Solar%20panel%20photovoltaic%20system%20inspection%20with%20technician%20testing%20solar%20panels%20on%20rooftop%2C%20measurement%20equipment%2C%20blue%20sky%20background%2C%20renewable%20energy%20technology&width=600&height=400&seq=9&orientation=landscape'
    },
    {
      icon: Wrench,
      title: t('services.teknik.equipment'),
      description: 'İş yerlerinde kullanılan ekipmanların güvenlik ve performans kontrolü',
      features: [
        'Güvenlik donanımları kontrolü',
        'Performans testleri',
        'Kalibrasyon işlemleri',
        'Bakım önerileri',
        'Uygunluk sertifikası'
      ],
      image: 'https://readdy.ai/api/search-image?query=Industrial%20equipment%20inspection%20with%20professional%20technician%20checking%20work%20machinery%2C%20safety%20equipment%2C%20factory%20environment%2C%20quality%20control%20procedures&width=600&height=400&seq=10&orientation=landscape'
    },
    {
      icon: AlertTriangle,
      title: 'Basınçlı Kaplar ve Kazanlar',
      description: 'Basınçlı kaplar ve buhar kazanlarının güvenlik kontrolü',
      features: [
        'Basınç testleri',
        'Güvenlik valfleri kontrolü',
        'Malzeme muayenesi',
        'Kaynak kontrolü',
        'İşletme izni belgesi'
      ],
      image: 'https://readdy.ai/api/search-image?query=Pressure%20vessel%20boiler%20inspection%20with%20technician%20examining%20industrial%20boiler%20systems%2C%20pressure%20gauges%2C%20safety%20valves%2C%20industrial%20facility%20background&width=600&height=400&seq=11&orientation=landscape'
    },
    {
      icon: Shield,
      title: 'Yangından Korunma Sistemi',
      description: 'Yangın güvenlik sistemlerinin kontrolü ve test edilmesi',
      features: [
        'Sprinkler sistemleri testi',
        'Yangın alarm sistemleri',
        'Acil çıkış yolları kontrolü',
        'Yangın söndürme cihazları',
        'Duman tahliye sistemleri'
      ],
      image: 'https://readdy.ai/api/search-image?query=Fire%20protection%20system%20inspection%20with%20technician%20testing%20sprinkler%20systems%2C%20fire%20alarms%2C%20emergency%20equipment%2C%20modern%20building%20safety%20systems&width=600&height=400&seq=12&orientation=landscape'
    }
  ];

  const inspectionProcess = [
    {
      step: '01',
      title: 'Randevu ve Planlama',
      description: 'Kontrol tarihinin belirlenmesi ve ön hazırlık'
    },
    {
      step: '02',
      title: 'Ön İnceleme',
      description: 'Ekipman ve sistemlerin görsel muayenesi'
    },
    {
      step: '03',
      title: 'Teknik Testler',
      description: 'Detaylı ölçüm ve performans testleri'
    },
    {
      step: '04',
      title: 'Güvenlik Kontrolü',
      description: 'Güvenlik sistemlerinin test edilmesi'
    },
    {
      step: '05',
      title: 'Rapor Hazırlama',
      description: 'Detaylı kontrol raporunun düzenlenmesi'
    },
    {
      step: '06',
      title: 'Belge Düzenleme',
      description: 'Uygunluk belgesi ve sertifika verilmesi'
    }
  ];

  const additionalServices = [
    {
      title: 'Kaldırma ve İletme Makineleri',
      description: 'Vinç, forklift ve diğer kaldırma ekipmanlarının kontrolü'
    },
    {
      title: 'Elektrik Tesisatları Kontrolü',
      description: 'Elektrik sistemlerinin güvenlik ve performans kontrolü'
    },
    {
      title: 'İş Makineleri Kontrolü',
      description: 'İnşaat ve sanayi makinelerinin periyodik kontrolü'
    },
    {
      title: 'Tezgah Makineleri Kontrolü',
      description: 'Üretim tezgahlarının güvenlik ve hassasiyet kontrolü'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-24 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Technical%20inspection%20services%20with%20professional%20technician%20using%20advanced%20testing%20equipment%2C%20industrial%20machinery%2C%20safety%20protocols%2C%20modern%20facility%20environment&width=1920&height=800&seq=13&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h1 className="text-5xl font-bold mb-6">{t('services.teknik.title')}</h1>
              <p className="text-xl leading-relaxed">
                {t('services.teknik.description')}
              </p>
            </div>
          </div>
        </section>

        {/* Main Services */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Teknik Kontrol Hizmetlerimiz</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Yasal zorunlulukları karşılayan kapsamlı teknik kontrol ve muayene hizmetleri
              </p>
            </div>

            <div className="space-y-16">
              {technicalServices.map((service, index) => (
                <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className="lg:w-1/2">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                  <div className="lg:w-1/2">
                    <div className="flex items-center mb-4">
                      <service.icon className="w-8 h-8 text-red-600 mr-3" />
                      <h3 className="text-3xl font-bold text-gray-800">{service.title}</h3>
                    </div>
                    <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-3 mb-6">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-start">
                          <CheckCircle className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
                      Kontrol Talep Et
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Additional Services */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Diğer Teknik Kontrol Hizmetleri</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Geniş hizmet yelpazemizle tüm teknik kontrol ihtiyaçlarınızı karşılıyoruz
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              {additionalServices.map((service, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <button className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
                    {t('common.learnMore')}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Inspection Process */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Kontrol Süreci</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Sistematik ve detaylı kontrol sürecimizle güvenliğinizi sağlıyoruz
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {inspectionProcess.map((step, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Technical Inspections */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Neden Teknik Kontroller Önemli?</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Periyodik teknik kontroller ile güvenliği ve verimliliği artırın
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Güvenlik</h3>
                <p className="text-gray-600">İş kazalarını önleme ve güvenli çalışma ortamı</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Yasal Uyumluluk</h3>
                <p className="text-gray-600">Yasal zorunlulukları karşılama ve ceza riskini azaltma</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Settings className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Verimlilik</h3>
                <p className="text-gray-600">Ekipman performansını artırma ve arıza önleme</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Eye className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Erken Tespit</h3>
                <p className="text-gray-600">Potansiyel sorunları erken tespit etme</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-red-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">Teknik Kontrol Randevunuzu Alın</h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Uzman teknik ekibimiz ile ekipmanlarınızın güvenli çalışmasını sağlayın. 
              Yasal zorunlulukları karşılayın ve iş güvenliğinizi artırın.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Randevu Al
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Fiyat Bilgisi
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
